import { useId, type SVGProps } from "react";

type StrokeIconProps = SVGProps<SVGSVGElement> & {
  size?: number;
  colors?: [string, string];
};

export const WhatsAppStrokeIcon: React.FC<
  SVGProps<SVGSVGElement> & {
    size?: number;
    colors?: [string, string];
  }
> = ({ size = 36, colors = ["#2A2D32", "#2A2D32"], ...props }) => {
  const id = useId();
  const gradientId = `gradient-${id}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.0613 10.7865C12.8385 10.6748 11.7428 10.1363 11.5388 10.0613C11.334 9.98703 11.1855 9.95028 11.0363 10.1738C10.8885 10.3965 10.461 10.8983 10.3312 11.0468C10.2015 11.196 10.071 11.214 9.84825 11.103C9.6255 10.9905 8.907 10.7558 8.05575 9.99678C7.3935 9.40578 6.94575 8.67603 6.816 8.45253C6.68625 8.22978 6.8025 8.10903 6.9135 7.99803C7.014 7.89828 7.137 7.73778 7.248 7.60803C7.35975 7.47753 7.3965 7.38453 7.4715 7.23528C7.54575 7.08678 7.509 6.95703 7.45275 6.84528C7.3965 6.73353 6.951 5.63628 6.76575 5.19003C6.58425 4.75578 6.4005 4.81503 6.264 4.80753C6.13425 4.80153 5.98575 4.80003 5.8365 4.80003C5.688 4.80003 5.4465 4.85553 5.2425 5.07903C5.0385 5.30178 4.4625 5.84103 4.4625 6.93828C4.4625 8.03478 5.26125 9.09453 5.37225 9.24378C5.484 9.39228 6.94425 11.6438 9.18 12.609C9.71175 12.8385 10.1265 12.9758 10.4505 13.0778C10.9845 13.248 11.4705 13.224 11.8538 13.1663C12.282 13.1025 13.1723 12.627 13.3583 12.1065C13.5443 11.586 13.5443 11.1398 13.488 11.0468C13.4325 10.9538 13.2848 10.8983 13.0613 10.7865ZM8.99475 16.3388H8.99175C7.66408 16.3389 6.36081 15.9819 5.2185 15.3053L4.94775 15.1448L2.142 15.8813L2.8905 13.1453L2.71425 12.8648C1.97208 11.683 1.57946 10.3153 1.58175 8.91978C1.5825 4.83228 4.90875 1.50678 8.99775 1.50678C10.9777 1.50678 12.8393 2.27928 14.2388 3.68028C14.9293 4.36774 15.4766 5.18533 15.849 6.08571C16.2214 6.9861 16.4116 7.95141 16.4085 8.92578C16.4063 13.0133 13.0807 16.3388 8.99475 16.3388ZM15.3045 2.61603C14.4781 1.78422 13.4949 1.12468 12.4118 0.675631C11.3287 0.226579 10.1673 -0.00305719 8.99475 3.07332e-05C4.0785 3.07332e-05 0.07725 4.00128 0.075 8.91903C0.075 10.491 0.48525 12.0255 1.266 13.3778L0 18L4.72875 16.7595C6.03644 17.472 7.50183 17.8453 8.991 17.8455H8.99475C13.9102 17.8455 17.9123 13.8443 17.9145 8.92578C17.9181 7.75374 17.6893 6.59261 17.2413 5.50956C16.7933 4.42651 16.135 3.44303 15.3045 2.61603Z"
        fill={`url(#${gradientId})`}
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="0"
          y1="0"
          x2="18"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors[0]} />
          <stop offset="1" stopColor={colors[1]} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const MailStrokeIcon: React.FC<
  SVGProps<SVGSVGElement> & {
    size?: number;
    colors?: [string, string];
  }
> = ({
  size = 36,
  colors = ["#2A2D32", "#2A2D32"],
  strokeWidth = 0.7,
  ...props
}) => {
  const id = useId();
  const gradientId = `gradient-${id}`;
  const stroke = strokeWidth != null ? Number(strokeWidth) : 0;
  const pad = stroke / 2;
  const viewBox = stroke
    ? `${-pad} ${-pad} ${18 + stroke} ${13 + stroke}`
    : "0 0 18 13";
  const paint = `url(#${gradientId})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.0345 2.39559L12.0439 7.18048L16.9942 11.475C17.0205 11.39 17.0345 11.2999 17.0345 11.2071L17.0345 2.39559ZM1.632 12.0887C1.68366 12.0983 1.73795 12.1035 1.7931 12.1035H16.1379C16.2027 12.1035 16.2658 12.0965 16.327 12.0834L11.3942 7.80371L10.5064 8.65474C9.83227 9.30176 8.77548 9.32278 8.07678 8.7029L7.02089 7.76781L1.632 12.0887ZM1.7931 0.896552C1.48754 0.896552 1.217 1.04977 1.05502 1.28355L8.67122 8.03212C9.02057 8.34118 9.5494 8.33154 9.88648 8.0076L16.8847 1.29669C16.7245 1.05592 16.4496 0.896556 16.1379 0.896556L1.7931 0.896552ZM0.896552 11.2069C0.896552 11.3067 0.913187 11.4021 0.942955 11.4914L6.33975 7.16446L0.896558 2.34101L0.896552 11.2069ZM17.931 11.2069C17.931 12.1971 17.1282 13 16.1379 13H1.7931C0.802862 13 0 12.1971 0 11.2069V1.7931C0 0.802862 0.802862 0 1.7931 0H16.1379C17.1282 0 17.931 0.802862 17.931 1.7931V11.2069Z"
        fill={paint}
        stroke={stroke ? paint : undefined}
        strokeWidth={stroke || undefined}
        strokeLinejoin={stroke ? "round" : undefined}
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="0"
          y1="0"
          x2="18"
          y2="13"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors[0]} />
          <stop offset="1" stopColor={colors[1]} />
        </linearGradient>
      </defs>
    </svg>
  );
};

/** Clipboard / copy affordance for shareable link boxes. */
export const CopyStrokeIcon: React.FC<
  SVGProps<SVGSVGElement> & {
    size?: number;
    colors?: [string, string];
  }
> = ({ size = 20, colors = ["#2A2D32", "#2A2D32"], ...props }) => {
  const id = useId();
  const gradientId = `copy-gradient-${id}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="9"
        y="9"
        width="13"
        height="13"
        rx="2"
        stroke={`url(#${gradientId})`}
        strokeWidth="1.75"
      />
      <path
        d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
        stroke={`url(#${gradientId})`}
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="2"
          y1="2"
          x2="22"
          y2="22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors[0]} />
          <stop offset="1" stopColor={colors[1]} />
        </linearGradient>
      </defs>
    </svg>
  );
};

/**
 * Navbar share control — same anatomy as lola `SupportIcon`:
 * brand-gradient circle (35) + white glyph inside.
 */
export const ShareStrokeIcon: React.FC<
  SVGProps<SVGSVGElement> & {
    size?: number;
    colors?: [string, string];
  }
> = ({ size = 35, colors = ["#2A2D32", "#2A2D32"], ...props }) => {
  const id = useId();
  const gradientId = `share-gradient-${id}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <circle cx="17.5" cy="17.5" r="17.5" fill={`url(#${gradientId})`} />
      <path
        d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
        transform="translate(7.9 7.9) scale(0.8)"
        stroke="white"
        strokeWidth="1.56"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="0"
          y1="17.5"
          x2="35"
          y2="17.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors[0]} />
          <stop offset="1" stopColor={colors[1]} />
        </linearGradient>
      </defs>
    </svg>
  );
};

/** Modest clipboard glyph for copy-to-clipboard controls. */
export const CopyIcon: React.FC<
  SVGProps<SVGSVGElement> & { size?: number }
> = ({ size = 16, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    {...props}
  >
    <rect
      x="5.25"
      y="5.25"
      width="8"
      height="9"
      rx="1.4"
      stroke="currentColor"
      strokeWidth="1.4"
    />
    <path
      d="M3.25 10.75V3.65A1.4 1.4 0 0 1 4.65 2.25h6.1"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>
);

/** Modest check used as the copied-state pair of CopyIcon. */
export const CheckIcon: React.FC<
  SVGProps<SVGSVGElement> & { size?: number }
> = ({ size = 16, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    {...props}
  >
    <path
      d="M3.2 8.2L6.5 11.4L12.8 4.6"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Filled circle used for initial / progress transaction status. */
export const StatusCircleIcon: React.FC<
  SVGProps<SVGSVGElement> & { size?: number; color?: string }
> = ({ size = 10, color = "#6b6b6b", className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden
    {...props}
  >
    <circle cx="5" cy="5" r="5" fill={color} />
  </svg>
);

type StatusMarkIconProps = SVGProps<SVGSVGElement> & {
  size?: number;
  color?: string;
};

/** Circle + three dots — pending / created status. */
export const StatusPendingIcon: React.FC<StatusMarkIconProps> = ({
  size = 10,
  color = "#F28D19",
  className,
  ...props
}) => {
  const clipId = `status-pending-clip-${useId()}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 8.30824 8.30824"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
      {...props}
    >
      <circle cx="4.15412" cy="4.15412" r="4.15412" fill={color} />
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M4.02974 4.40587C4.16879 4.40587 4.28151 4.29315 4.28151 4.15411C4.28151 4.01506 4.16879 3.90234 4.02974 3.90234C3.8907 3.90234 3.77798 4.01506 3.77798 4.15411C3.77798 4.29315 3.8907 4.40587 4.02974 4.40587Z"
          stroke="white"
          strokeWidth="0.503529"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.7921 4.40587C5.93114 4.40587 6.04386 4.29315 6.04386 4.15411C6.04386 4.01506 5.93114 3.90234 5.7921 3.90234C5.65305 3.90234 5.54033 4.01506 5.54033 4.15411C5.54033 4.29315 5.65305 4.40587 5.7921 4.40587Z"
          stroke="white"
          strokeWidth="0.503529"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.26739 4.40587C2.40644 4.40587 2.51915 4.29315 2.51915 4.15411C2.51915 4.01506 2.40644 3.90234 2.26739 3.90234C2.12834 3.90234 2.01562 4.01506 2.01562 4.15411C2.01562 4.29315 2.12834 4.40587 2.26739 4.40587Z"
          stroke="white"
          strokeWidth="0.503529"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect
            width="6.04235"
            height="6.04235"
            fill="white"
            transform="translate(1.00781 1.13281)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

/** Circle + X — failed / cancelled / expired status. */
export const StatusFailedIcon: React.FC<StatusMarkIconProps> = ({
  size = 10,
  color = "#FF3B30",
  className,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 8.30824 8.30824"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden
    {...props}
  >
    <circle cx="4.15412" cy="4.15412" r="4.15412" fill={color} />
    <path
      d="M5.28718 2.89453L2.76953 5.41218M2.76953 2.89453L5.28718 5.41218"
      stroke="white"
      strokeWidth="0.503529"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Figma storefront vector for the "See stores" mark. Fill follows theme. */
export const StorefrontIcon: React.FC<
  StrokeIconProps & { color?: string }
> = ({
  size = 20,
  color,
  colors = ["#051510", "#051510"],
  ...props
}) => {
  const fill = color ?? colors[0];
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 2234 2234"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        d="M1462.15 1140.28C1383.42 1243.87 1253.61 1305.99 1114.76 1305.99C975.911 1305.97 846.086 1243.89 767.371 1140.28C698.907 1230.55 591.056 1289.98 471.122 1303.22C355.016 1316.03 238.664 1284.26 149.531 1216.45V2085.67H673.075V1446.96C673.075 1406.44 708.948 1376.17 749.709 1376.17H1495.17C1510.06 1376.17 1524.64 1380.17 1537.1 1387.69L1548.77 1396.29C1563.26 1409.41 1571.81 1427.69 1571.81 1446.96V2083.36L2079.99 2085.51V1216.45C1990.87 1284.22 1874.62 1316.02 1758.55 1303.22C1638.59 1289.99 1530.62 1230.58 1462.15 1140.28ZM826.345 2083.36H1418.54V1517.75H826.345V2083.36ZM149.531 921.597C146.183 987.494 172.768 1052.11 223.708 1100.35C274.699 1148.63 345.643 1176.22 420.134 1176.22C494.615 1176.22 565.545 1148.62 616.558 1100.35C667.483 1052.11 694.103 987.489 690.736 921.597V677.265H149.531V921.597ZM1538.79 921.597C1535.42 987.489 1562.03 1052.11 1612.97 1100.35C1663.97 1148.63 1734.91 1176.21 1809.39 1176.22C1883.87 1176.22 1954.83 1148.62 2005.81 1100.35C2056.75 1052.11 2083.34 987.494 2079.99 921.597V677.265H1538.79V921.597ZM843.851 918.525C843.851 1004.73 894.7 1085.36 978.693 1129.23C1062.82 1173.13 1166.7 1173.13 1250.83 1129.23C1334.83 1085.35 1385.67 1004.73 1385.67 918.525V675.116H843.851V918.525ZM1517.9 533.523H2021.17L1767.62 141.763H1380.45L1517.9 533.523ZM870.421 533.523H1356.49L1217.5 141.763H995.432L870.421 533.523ZM194.53 533.523H710.239L835.865 141.763H397.251L194.53 533.523ZM2233.1 2158.61C2233.09 2177.89 2224.7 2196.03 2210.22 2209.13C2195.77 2222.23 2176.44 2229.25 2156.62 2229.26H1518.82C1515.57 2230.25 1512.34 2231.28 1508.99 2231.87L1495.17 2233.1H747.713C740.088 2232.14 732.674 2229.97 725.598 2227.11H76.5828C56.7562 2227.09 37.4255 2220.05 22.9844 2207C8.44978 2193.86 0.101562 2175.59 0.101562 2156.31V603.09C0.126316 596.501 1.43744 590.074 3.63377 583.894V579.595L5.47673 576.215L279.304 40.0992C292.451 15.1478 319.72 0.182906 348.567 0.32428L1809.07 0.170638C1823.72 -0.443921 1838.06 2.95047 1850.54 9.53858L1879.58 36.5671L2207 540.587L2207.92 536.594L2215.14 553.18L2226.36 570.379L2228.97 574.374V582.82H2228.81C2228.86 583.487 2228.64 584.147 2228.65 584.816C2231.23 591.653 2232.88 598.766 2233.1 606.009V2158.61Z"
        fill={fill}
      />
    </svg>
  );
};

/** Thin circled "i" used in confirmation drawers and hero marks. */
export const InfoCircleIcon: React.FC<StrokeIconProps> = ({
  size = 40,
  colors = ["#2A2D32", "#2A2D32"],
  ...props
}) => {
  const id = useId();
  const gradientId = `info-circle-gradient-${id}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke={`url(#${gradientId})`}
        strokeWidth="1.6"
      />
      <circle cx="12" cy="8.2" r="1.15" fill={`url(#${gradientId})`} />
      <path
        d="M12 11.2v5.4"
        stroke={`url(#${gradientId})`}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="2"
          y1="12"
          x2="22"
          y2="12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors[0]} />
          <stop offset="1" stopColor={colors[1]} />
        </linearGradient>
      </defs>
    </svg>
  );
};

/** Circle + exclamation — error / alert hero mark. Colors follow theme. */
export const ErrorAlertIcon: React.FC<
  SVGProps<SVGSVGElement> & { size?: number; colors?: [string, string] }
> = ({ size = 65, colors = ["#2A2D32", "#2A2D32"], className, ...props }) => {
  const id = useId();
  const paintId = `error-alert-paint-${id}`;
  const paint = `url(#${paintId})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 58 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
      {...props}
    >
      <path
        d="M28.1826 40.0202C27.9708 40.0202 27.7907 39.9461 27.6425 39.7978C27.4942 39.6495 27.4201 39.4695 27.4201 39.2577V24.2609C27.4201 24.0491 27.4942 23.869 27.6425 23.7207C27.7907 23.5725 27.9708 23.4983 28.1826 23.4983H30.8198C31.0528 23.4983 31.2328 23.5725 31.3599 23.7207C31.5082 23.869 31.5823 24.0491 31.5823 24.2609V39.2577C31.5823 39.4695 31.5082 39.6495 31.3599 39.7978C31.2328 39.9461 31.0528 40.0202 30.8198 40.0202H28.1826ZM28.0555 20.7659C27.8437 20.7659 27.6637 20.6917 27.5154 20.5435C27.3671 20.3952 27.293 20.2151 27.293 20.0033V17.7157C27.293 17.5039 27.3671 17.3238 27.5154 17.1755C27.6637 17.0273 27.8437 16.9531 28.0555 16.9531H30.9468C31.1798 16.9531 31.3705 17.0273 31.5188 17.1755C31.667 17.3238 31.7412 17.5039 31.7412 17.7157V20.0033C31.7412 20.2151 31.667 20.3952 31.5188 20.5435C31.3705 20.6917 31.1798 20.7659 30.9468 20.7659H28.0555Z"
        fill={paint}
      />
      <path
        d="M28.7977 55.7477C43.6817 55.7477 55.7477 43.6817 55.7477 28.7977C55.7477 13.9136 43.6817 1.84766 28.7977 1.84766C13.9136 1.84766 1.84766 13.9136 1.84766 28.7977C1.84766 43.6817 13.9136 55.7477 28.7977 55.7477Z"
        stroke={paint}
        strokeWidth="3.696"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={paintId}
          x1="1.85"
          y1="28.8"
          x2="55.75"
          y2="28.8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors[0]} />
          <stop offset="1" stopColor={colors[1]} />
        </linearGradient>
      </defs>
    </svg>
  );
};

/** Info mark on a light-gray disc — transaction-limit sheet (Figma). */
export const LimitInfoIcon: React.FC<StrokeIconProps> = ({
  size = 60,
  colors = ["#2A2D32", "#2A2D32"],
  ...props
}) => {
  const id = useId();
  const paintId = `limit-info-paint-${id}`;
  const paint = `url(#${paintId})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <circle cx="30" cy="30" r="30" fill="#EEEEEE" />
      <g transform="translate(14 14)">
        <rect
          x="0.842105"
          y="0.842105"
          width="30.3158"
          height="30.3158"
          rx="15.1579"
          stroke={paint}
          strokeWidth="1.68421"
        />
        <path
          d="M14.9535 23C14.8158 23 14.6987 22.9518 14.6023 22.8554C14.5059 22.759 14.4576 22.6419 14.4576 22.5041V12.7521C14.4576 12.6143 14.5059 12.4972 14.6023 12.4008C14.6987 12.3044 14.8158 12.2562 14.9535 12.2562H16.6684C16.8199 12.2562 16.937 12.3044 17.0196 12.4008C17.116 12.4972 17.1643 12.6143 17.1643 12.7521V22.5041C17.1643 22.6419 17.116 22.759 17.0196 22.8554C16.937 22.9518 16.8199 23 16.6684 23H14.9535ZM14.8709 10.4793C14.7331 10.4793 14.616 10.4311 14.5196 10.3347C14.4232 10.2383 14.375 10.1212 14.375 9.98347V8.49587C14.375 8.35813 14.4232 8.24105 14.5196 8.14463C14.616 8.04821 14.7331 8 14.8709 8H16.751C16.9025 8 17.0265 8.04821 17.1229 8.14463C17.2194 8.24105 17.2676 8.35813 17.2676 8.49587V9.98347C17.2676 10.1212 17.2194 10.2383 17.1229 10.3347C17.0265 10.4311 16.9025 10.4793 16.751 10.4793H14.8709Z"
          fill={paint}
        />
      </g>
      <defs>
        <linearGradient
          id={paintId}
          x1="1"
          y1="16"
          x2="31"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors[0]} />
          <stop offset="1" stopColor={colors[1]} />
        </linearGradient>
      </defs>
    </svg>
  );
};

